import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "number5CircleFilled"
const Number5CircleFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M12 1.5C17.799 1.5 22.5 6.201 22.5 12S17.799 22.5 12 22.5 1.5 17.799 1.5 12 6.201 1.5 12 1.5M8.9 12.565 10.16 12.745C10.61 12.37 11.195 12.175 11.705 12.175 12.2 12.175 12.65 12.31 12.98 12.595 13.385 12.94 13.625 13.45 13.625 14.02 13.625 14.56 13.4 15.04 13.04 15.37 12.695 15.685 12.245 15.85 11.78 15.85 11.075 15.85 10.43 15.49 9.98 15.01L8.6 16.3C9.515 17.215 10.565 17.65 11.78 17.65 13.895 17.65 15.65 16.09 15.65 14.02 15.65 12.895 15.14 11.83 14.315 11.17 13.58 10.57 12.68 10.375 11.87 10.375 11.585 10.375 11.27 10.405 11.06 10.45L11.225 8.8H15.125V7H9.575z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default Number5CircleFilledIcon
